export interface ITicketStatus{
  id: number;
  description: string;
}

export enum TicketStatus{
  Approved = 1,
  PendingApproval = 2,
  Planned = 3
}